module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('Loader') : _c('section', [(!_vm.showCreateArtFormComment) ? _c('button', {
    staticClass: "button is-info mb-2",
    on: {
      "click": function($event) {
        _vm.showCreateArtFormComment = true
      }
    }
  }, [_vm._v("Add Comment")]) : _c('CreateArtFormComment', {
    attrs: {
      "videoID": _vm.videoID,
      "currentTime": _vm.currentTime
    },
    on: {
      "close": function($event) {
        _vm.showCreateArtFormComment = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', [_c('ArtFormComment', {
      attrs: {
        "comment": comment
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4de33faa"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArtsFormComments.vue
// module id = 1031
// module chunks = 0